const iState = {
  theme: 0,
  pfdata: [],
  pfdatamaster: [],
  pfdatamodal: [],
  total: 0,
  totalmaster: 0,
  totalmodal: 0,
  admin_pf: 0,
  totaladmin_pf: 0,
  totalmodaladmin_pf: 0,
  mode: 0,
  adv: 1,
  show: 0,
  symbol: "",
  user_id: "",
};

const Reducer = (state = iState, action) => {
  switch (action.type) {
    case "SYMBOL":
      return { ...state, symbol: action.payload };

    case "SHOW":
      return { ...state, show: action.payload };

    case "USER_ID":
      return { ...state, user_id: action.payload };

    case "THEME":
      return { ...state, theme: action.payload };

    case "MODE":
      return { ...state, mode: action.payload };

    case "ADV":
      return { ...state, adv: action.payload };

    case "CLEAR_PF":
      return { ...state, pfdata: [], total: 0, admin_pf: 0 };

    case "CLEAR_PFMASTER":
      return { ...state, pfdatamaster: [], totalmaster: 0, totaladmin_pf: 0 };

    case "CLEAR_PFMODAL":
      return {
        ...state,
        pfdatamodal: [],
        totalmodal: 0,
        totalmodaladmin_pf: 0,
      };

    case "PF": {
      if (action.total > 0) {
        const index = state.pfdata.findIndex(
          (i) => i.symbol_id === action.symbol_id
        );

        const updated =
          index !== -1
            ? state.pfdata.map((i, idx) =>
                idx === index
                  ? { ...i, pf: action.pf, admin_pf: action.admin_pf }
                  : i
              )
            : [
                ...state.pfdata,
                {
                  symbol_id: action.symbol_id,
                  pf: action.pf,
                  admin_pf: action.admin_pf,
                },
              ];

        const total = updated.reduce((sum, i) => sum + parseFloat(i.pf), 0);
        const totaladmin = updated.reduce(
          (sum, i) => sum + parseFloat(i.admin_pf),
          0
        );

        return {
          ...state,
          pfdata: updated,
          total: total,
          admin_pf: totaladmin,
        };
      }
      return state;
    }

    case "PFMASTER": {
      if (action.total > 0) {
        const index = state.pfdatamaster.findIndex(
          (i) => i.symbol_id === action.symbol_id
        );

        const updated =
          index !== -1
            ? state.pfdatamaster.map((i, idx) =>
                idx === index
                  ? { ...i, pf: action.pf, totaladmin_pf: action.totaladmin_pf }
                  : i
              )
            : [
                ...state.pfdatamaster,
                {
                  symbol_id: action.symbol_id,
                  pf: action.pf,
                  totaladmin_pf: action.totaladmin_pf,
                },
              ];

        const totalmaster = updated.reduce(
          (sum, i) => sum + parseFloat(i.pf),
          0
        );
        const totaladminsharing = updated.reduce(
          (sum, i) => sum + parseFloat(i.totaladmin_pf),
          0
        );
        return {
          ...state,
          pfdatamaster: updated,
          totalmaster: totalmaster,
          totaladmin_pf: totaladminsharing,
        };
      }
      return state;
    }

    case "PFMODAL": {
      if (action.total > 0) {
        const index = state.pfdatamodal.findIndex(
          (i) => i.symbol_id === action.symbol_id
        );

        const updated =
          index !== -1
            ? state.pfdatamodal.map((i, idx) =>
                idx === index
                  ? { ...i, pf: action.pf, totalmodaladmin_pf: action.admin_pf }
                  : i
              )
            : [
                ...state.pfdatamodal,
                {
                  symbol_id: action.symbol_id,
                  pf: action.pf,
                  totalmodaladmin_pf: action.admin_pf,
                },
              ];

        const totalmodalmaster = updated.reduce(
          (sum, i) => sum + parseFloat(i.pf),
          0
        );
        const totalmodaladminsharing = updated.reduce(
          (sum, i) => sum + parseFloat(i.totalmodaladmin_pf),
          0
        );
        return {
          ...state,
          pfdatamodal: updated,
          totalmodal: totalmodalmaster,
          totalmodaladmin_pf: totalmodaladminsharing,
        };
      }
      return state;
    }

    default:
      return state;
  }
};

export default Reducer;
